// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"31":"c4f164a3db6b3e22","1154":"59fe14028afcee43","4335":"8ade20c01531f72f","5939":"585d32b8b18324c7","8939":"24b279ef25b623d4","9755":"8f05c151af24d1c9"}[chunkId] + ".js";
};